import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupsAppGroupIdCacheKeys: AllRouteEndpoints[] = ["/apps/app_group", "/apps/app_groups"];
export const postAddNewAppCacheKeys: AllRouteEndpoints[] = ["/apps/app_group"];
